<template>
    <SearchResultsItem v-for="line in searchItems" v-bind:key="line.partUniqueId" v-bind:searchItem="line"></SearchResultsItem>
</template>

<script>
    import SearchResultsItem from './search-results-item.vue'
    export default {
        name: 'SearchResultPane',
        components: {
            SearchResultsItem
        },
        props: {
            searchItems: {
                type: Array,
                default: () => {
                    return []
                }
            }
        }
    };
</script>

<style scoped>
</style>